import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
  return (
    <button
      onClick={() => openWhatsApp("general")}
      data-testid="whatsapp-float-btn"
      aria-label="Chat with Bonsai Financial on WhatsApp"
      className="wa-pulse fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg shadow-[#25D366]/30 transition-transform hover:scale-105 active:scale-95"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="hidden text-sm font-semibold sm:inline">WhatsApp</span>
    </button>
  );
}
